module.exports = __webpack_public_path__ + "img/whiteboard.b03718f1.svg";